import { Controller } from "@hotwired/stimulus"
import axios from 'axios';

import {
  getMetaValue
} from "../../components/shared/dom_helpers";

export default class extends Controller {
  static targets = [
    "existingDocument",
    "subkindSelection",
    "subkindsSelectionForm",
    "frontBackSelectionForm",
    "frontAndBackTogetherDocuments",
    "frontAndBackSeparateDocuments",
    "backToSubkindsSelection",
    "backToStart",
    "editButton",
    "errorWrapper"
  ]

  static values = {
    existingDocument: Boolean,
    kind: String,
    selectedSubkind: String,
    frontAndBackTogether: {type: Boolean, default: true},
    frontAndBackChoice: {type: Boolean, default: false},
    numberOfDocuments: {type: Number, default: 1},
    uplodedDocumentsCount: {type: Number, default: 0},
  }

  connect() {
    this.kindValue = JSON.parse(this.element.dataset.kind)
    this.selectedSubkindValue = JSON.parse(this.element.dataset.defaultSubkind)?.type || "";
    console.log(this.selectedSubkindValue)
    this.availableSubkinds = JSON.parse(this.element.dataset.subkindsToDisplay) || [];
    this.submitParams = JSON.parse(this.element.dataset.submitParams) || {};
    this.existingDocumentValue = JSON.parse(this.element.dataset.existingDocument) || false;
    if (this.selectedSubkindValue !== "") { this.subkindSelected() }
    this.initializeDropzoneCallbacks()
  }

  edit(e) {
    e.preventDefault();
    this.existingDocumentTarget.classList.add("d-none");
    this.editButtonTarget.classList.add("d-none");
    this.subkindSelectionTarget.classList.remove("d-none");
    this.subkindsSelectionFormTarget.classList.remove("d-none");
    this.frontBackSelectionFormTarget.classList.add("d-none");
    this.errorWrapperTarget.classList.add("d-none");
    this.frontAndBackTogetherDocumentsTarget.classList.add("d-none");
    this.frontAndBackSeparateDocumentsTarget.classList.add("d-none");
    this.backToStartTarget.classList.add("d-none");
  }

  selectSubkind(e) {
    e.preventDefault();
    this.selectedSubkindValue = e.target.dataset.subkind;
    this.subkindSelected();
  }

  subkindSelected() {
    this.subkindsSelectionFormTarget.classList.add("d-none");
    if ( this.availableSubkinds.find(subkind => subkind.type === this.selectedSubkindValue)?.has_front_back) {
      this.frontAndBackChoiceValue = false;
      this.frontBackSelectionFormTarget.classList.remove("d-none");
      this.frontAndBackTogetherDocumentsTarget.classList.add("d-none");
      this.backToSubkindsSelectionTarget.classList.remove("d-none");
      this.backToStartTarget.classList.add("d-none");
    } else {
      this.frontAndBackChoiceValue = true;
      this.frontBackSelectionFormTarget.classList.add("d-none");
      this.frontAndBackTogetherDocumentsTarget.classList.remove("d-none");
      if (this.existingDocumentValue) {
        this.backToStartTarget.classList.remove("d-none");
        this.backToSubkindsSelectionTarget.classList.add("d-none");
      } else {
        this.backToSubkindsSelectionTarget.classList.remove("d-none");
      }
    }
  }

  setFrontAndBackDocuments(e) {
    e.preventDefault();
    this.frontAndBackTogetherValue = e.target.dataset.value === "true";
    this.frontAndBackChoiceValue = true;
    this.frontBackSelectionFormTarget.classList.add("d-none");
    if (this.frontAndBackTogetherValue) {
      this.numberOfDocumentsValue = 1;
      this.frontAndBackTogetherDocumentsTarget.classList.remove("d-none");
    } else {
      this.numberOfDocumentsValue = 2;
      this.frontAndBackSeparateDocumentsTarget.classList.remove("d-none");
    }
    this.backToSubkindsSelectionTarget.classList.add("d-none");
    this.backToStartTarget.classList.remove("d-none");
  }


  returnToSubkindsSelection() {
    this.subkindsSelectionFormTarget.classList.remove("d-none");
    this.frontBackSelectionFormTarget.classList.add("d-none");
    this.frontAndBackTogetherDocumentsTarget.classList.add("d-none");
    this.frontAndBackSeparateDocumentsTarget.classList.add("d-none");
    this.backToSubkindsSelectionTarget.classList.add("d-none");
  }

  initializeDropzoneCallbacks() {
    this.element.querySelectorAll(".dropzone-wrapper").forEach(dropzoneWrapper => {
      dropzoneWrapper.addEventListener("dropzone:upload:success", (e) => {
        this.uplodedDocumentsCountValue++;
        this.submitDocument({element: dropzoneWrapper, fieldName: e.detail.fieldName, filePath: e.detail.filePath});
      })
      dropzoneWrapper.addEventListener("dropzone:upload:processing", () => {
        this.documentProcessing({element: dropzoneWrapper});
      })
      dropzoneWrapper.addEventListener("dropzone:upload:error", (e) => {
        this.documentError({element: dropzoneWrapper, error: e.detail.error});
      })
    })
  }

  returnToStart() {
    if (this.existingDocumentValue) {
      this.existingDocumentTarget.classList.remove("d-none");
      this.editButtonTarget.classList.remove("d-none");
      this.subkindSelectionTarget.classList.add("d-none");
    } else {
        this.subkindSelectionTarget.classList.remove("d-none");
    }
    this.subkindsSelectionFormTarget.classList.remove("d-none");
    this.frontBackSelectionFormTarget.classList.add("d-none");
    this.frontAndBackTogetherDocumentsTarget.classList.add("d-none");
    this.frontAndBackSeparateDocumentsTarget.classList.add("d-none");
    this.backToSubkindsSelectionTarget.classList.add("d-none");
    this.backToStartTarget.classList.add("d-none");
    this.selectedSubkindValue = "";
  }

  submitDocument({element, fieldName, filePath}) {
    if(this.submitParams.submit_type === "auto") {
      this.autoSubmitForm({element, fieldName, filePath});
    }
    else if(this.submitParams.submit_type === "form") {
      this.attachfilePathToInput(element, filePath);
    }
  }

  autoSubmitForm({element, fieldName, filePath}) {
    const formData = new FormData();
    formData.append(`user_account[${fieldName}][subkind]`, this.selectedSubkindValue);
    formData.append(`user_account[${fieldName}][document]`,filePath);
    formData.append(`front_and_back_together`, this.frontAndBackTogetherValue);
    formData.append('authenticity_token', getMetaValue("csrf-token"));
    const headers = {'Content-Type': 'multipart/form-data' }
    axios[this.submitParams.submit_method.toLowerCase()](this.submitParams.submit_path,formData, {headers: headers}).then(res => this.handleAutoSubmitResponse(element, res))
  }

  attachfilePathToInput(element, filePath) {
    element.style.opacity = 1;
    element.style.pointerEvents = "auto";
    document.getElementById(this.submitParams.submit_input_id).value = filePath;
  }

  handleAutoSubmitResponse(element, response) {
    if (response.data.success) {
      element.style.opacity = 1;
      element.style.pointerEvents = "auto";
      this.backToStartTarget.classList.add("d-none");
      let event = new Event(`document:${this.kindValue}:upload:success`)
      window.dispatchEvent(event)
    } else {
      this.errorWrapperTarget.classList.remove("d-none");
      this.errorWrapperTarget.textContent = response.data.message;
      element.style.opacity = 1;
      element.style.pointerEvents = "auto";
    }
  }

  documentProcessing({element}) {
    element.style.opacity = 0.5
    element.style.pointerEvents = "none"
  }

  documentError({element, error}) {
    element.style.opacity = 1;
    element.style.pointerEvents = "auto";
    // Note: Dropzone already handles upload error display
  }
}